import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal';
import PricingMatrix from '../PricingMatrix';
import { closePricingModal } from '../../sagas/pricingModal/actions';

const PricingModalGlobal = () => {
  const dispatch = useDispatch();
  const { open } = useSelector(s => s.pricingModal);

  return (
    <Modal open={open} closeModal={() => dispatch(closePricingModal())}>
      <PricingMatrix currentTier="freemium" />
    </Modal>
  );
};

export default PricingModalGlobal;
